/*global
    aap
*/
(function ($, w, d) {
    // feature detection for drag&drop upload

    'use strict';

    //check for drag and drop features
    var isDragDropSupported = (function () {
        var div = d.createElement('div'),
            isDroppable = (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div));
        return isDroppable && 'FormData' in w && 'FileReader' in w;
    }());

    function insertLoadingGraphic(elem) {
        $('body').append('<div class="loading-overlay"></div>');
    }

    function showLoadingGraphic(elem) {
        var loadingGraphic = $('body').find('div.loading-graphic');
        
        setTimeout(function () {
                if (typeof loadingGraphic === 'undefined' || loadingGraphic.length == 0) {
                    insertLoadingGraphic(elem);
                } else {
                    $('body').find('div.loading-overlay').css('display', 'block');
                }
        }, 200);
    }

    function hideLoadingGraphic(elem) {
        $('body').find('div.loading-overlay').css('display', 'none');
    }

    var recordsSuccess = function (data) {
        var records = data.records,
            $uploaded = $('.uploaded'),
            ml = [],
            tmpl = '<li data-id="{2}"><a href="{0}">{1}</a><span>x</span></li>';

        $('.file-text').hide();

        function addToML(value) {
            var split = value.url.split('/'),
                id = value.id,
                fileName = split[split.length - 1];
            ml.push(aap.stringformat(tmpl, value.url, fileName, id));
        }

        records.forEach(addToML);
        $uploaded.html(ml.join(''));
    };

    function maybeDisableOrEnableUpload() {
        if ($('div.is_owner_edit_pet').length > 0) {
            var photoCount = $('div.edit-gallery').length;
            var youtubeCount = $('div.youtube-player').find('img').length;
            var $photoButton = $('div#photo-edit-buttons');
            var $videoButton = $('div#video-edit-buttons');
            if (photoCount >= 4) {
                // hide button
                $photoButton.hide();
            } else {
                // show button
                $photoButton.show();
            }

            if (youtubeCount > 0) {
                // hide button
                $videoButton.hide();
            } else {
                // show button
                $videoButton.show();
            }
        }
    };

    var dropAndUplaod = function () {
        var $this = $(this),
            $form = $this.parents('form'),
            $input = $this.find('[type="file"]'),
            $label = $this.find('label'),
            droppedFiles = false,
            showFiles = function (files, el) { //display uploaded files
                var isMultiFiles = files.length > 1,
                    fileNames = '1 file selected'; //just one ? so display name

                if (isMultiFiles) {
                    //or display how many
                    fileNames = aap.stringformat($input.data('multiple-caption'), files.length);
                }

                if ( $('.file-text').length > 0 ) {
                    $label.find('.file-text').text(fileNames);
                }
                $this.addClass('upload');
                $form.trigger('submit', [el.parents('.drop-zone')]);
            };

        //$form.append('<input type="hidden" name="ajax" value="1" />');

        $input.on('change', function (e) {
            showFiles(e.target.files, $(this));
        });

        //drag and drop file
        if (isDragDropSupported) {
            $form
                .addClass('has-drag-support');
            $this
                .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                    // preventing the unwanted behaviours
                    e.preventDefault();
                    e.stopPropagation();
                })
                .on('dragover dragenter', function () {
                    $form.addClass('is-dragover');
                })
                .on('dragleave dragend drop', function () {
                    $form.removeClass('is-dragover');
                })
                .on('drop', function (e) {
                    droppedFiles = e.originalEvent.dataTransfer.files; // the files that were dropped
                    showFiles(droppedFiles, $(e.target)); //pass where dropped as param
                });
        }

        // if the form was submitted
        $form.on('submit', function (e, el) {
            // preventing the duplicate submissions if the current one is in progress
            var $dropzone = el,
                url = $dropzone.data('url');


            if ($form.hasClass('is-uploading')) {
                return false;
            }

            $form.addClass('is-uploading').removeClass('is-error');

            var rank = $dropzone.find('input').data('rank'),
                $fileUploading = $('.uploading-' + rank);

            $fileUploading.show();

            if (isDragDropSupported) {
                e.preventDefault();

                var photo_count;
                // gathering the form data
                var ajaxData = new FormData($form.get(0));
                if ($("div#is_owner_edit_pet")) {
                    photo_count = $("div.edit-gallery").length;
                    $form.find('input[name="photo_count"]').val(photo_count);
                    showLoadingGraphic($form.parents('div'));
                }

                if (droppedFiles) {
                    $.each(droppedFiles, function (i, file) {
                        ajaxData.append($input.attr('name'), file);
                    });
                }

                // ajax request
                var xhr = $.ajax({
                    url: url,
                    type: $form.attr('method'),
                    data: ajaxData,
                    dataType: 'json',
                    cache: false,
                    contentType: false,
                    headers:{
                        'X-CSRF-TOKEN': $form.find('input[name="_token"]').val()
                    },
                    processData: false
                });


                xhr
                    .always(function () {
                        //clean up
                        $form.removeClass('is-uploading').trigger('reset');
                        $fileUploading.hide();
                        hideLoadingGraphic($form.parents('div'));
                    })
                    .done(function (data) {

                        if(data.records) {
                            recordsSuccess(data);
                            return;
                        }
                        var files, $text,
                            photos = ['photo_1_id','photo_2_id','photo_3_id','photo_4_id'],
                            $photoCount = $('#photo_count'),
                            replacePhotos;

                        // on step 7 which photo to replace
                        replacePhotos = photos.filter(function(value) {
                           return data[value];
                        });

                        // on step 7 replace photo
                        if(replacePhotos.length > 0) {
                            var photo = replacePhotos[0],
                                $el = $('[for="default_' + photo + '"]').find('img');

                            $el.attr('src', data[photo]);
                            return;
                        }

                        //pet edit replace video
                        if(data.videos && data.videos.length > 0) {
                            var $player = $('.youtube-player');
                            var id = data.videos[0].video_id;
                            //video div
                            var p = document.createElement('div');

                            //populate div with video thumbnail
                            p.innerHTML = aap.youtube.thumb(id);
                            //attach event to thumbnail to get youtube iframe
                            p.onclick = aap.youtube.iframe;
                            $player.html($(p));
                        }

                        //display images on uploaded
                        if(data.photos && data.photos.length > 0) {
                            var $display;
                            if ( $('div.is_owner_edit_pet').length > 0 ) {
                                $display = $('.display');
                                $display.find('div.edit-gallery').remove();
                            } else {
                                $display = $('.display').empty();
                            }

                            $.each(data.photos, function(i,v){
                                var imgTmpl;
                                var $img;
                                var isOwnerEdit = $('div.is_owner_edit_pet').length > 0;
                                if (isOwnerEdit) {
                                    var count = parseInt(v.id.match(/\d+/)[0], 10);
                                    if (isOwnerEdit) {
                                        var petId = $('input[name="pet_id"]').val();
                                        imgTmpl = '<div class="edit-gallery order-div"><label for="default_photo_'+count+'_id"><form method="POST" action="" class="upload_photo_form" id="upload_photo_form_'+count+'"><input type="hidden" name="_token" value="jWdctI6oGec5dFOweSldsVv6fwSeDprEpZfHSKFR"><input type="hidden" name="rank" value="'+count+'"><input type="hidden" name="pet_id" value="'+petId+'"><input type="file" name="'+v.id+'" class="edit_photo_field" id="upload_photo_'+count+'_field" style="display:none;"><button class="edit-photo"></button><ul class="edit-photo-menu"><li class="replacePhoto">Replace</li><li class="deletePhoto">Delete</li><li class="makePrimary">Make primary photo</li></ul></form><img class="previewPhoto" src="'+v.url+'" alt="" id="preview-photo-'+count+'"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#aap-icon-checked"></use></svg></label><label class="file" for="photo_'+count+'_id"><div class="uploading uploading-'+count+'"><div class="bar"></div></div><span class="error" style="display: none;">Oops!</span></label></div>';
                                    } else {
                                        imgTmpl = '<div class="edit-gallery order-div"><input id="default_'+v.id+'" data-optional="1" name="photo_order" type="radio" value="1"><label for="default_'+v.id+'"><img src="'+v.url+'" alt=""><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#aap-icon-checked"></use></svg></label><label class="file" for="'+v.id+'"><span>Replace</span><div class="uploading uploading-'+count+'"><div class="bar"></div></div><span class="error" style="display: none;">Oops!</span></label></div>';
                                    }
                                    $img = $(imgTmpl);
                                } else {
                                    imgTmpl = '<div><img src="{0}"></div>';
                                    $img = $(aap.stringformat(imgTmpl, v.url));
                                }

                                

                                $img.appendTo($display);
                            });
                        }

                        //display any errors
                        if (!data.photos && !data.videos) {
                            $form.addClass('is-error');
                            return;
                        }

                        //dom replacement with new image here
                        $photoCount.val(data.photos.length);
                        aap.uploaded = data.photos || data.videos;
                        files = data.photos ? data.photos.length : data.videos.length;
                        if ( $('.file-text').length > 0 ) {
                            $text = data.photos ? $label.find('.file-text') : $label.find('.file-text.video');
                            $text.text(aap.stringformat('{0} files uploaded',files));
                        }
                        $('.upload-error').removeClass('nouploads');
                        maybeDisableOrEnableUpload();
                        if ( $('div.is_owner_edit_pet').length > 0 ) {
                            window.location.reload();
                        }

                    })
                    .fail(function () {
                        //oops
                        $form.addClass('is-error');
                    });

            }
        });

        // Firefox focus bug fix for file input
        $input
            .on('focus', function () {
                $input.addClass('has-focus');
            })
            .on('blur', function () {
                $input.removeClass('has-focus');
            });
    };

    function deleteIt() {
        /*jshint validthis: true */
        var $li = $(this),
            file = $li.data('id'),
            $uploaded = $('.uploaded'),
            $form = $('#records-form');

        function removeIt() {
            $li.fadeOut().remove();
        }

        $.ajax({
            type: 'POST',
            headers:{ 'X-CSRF-TOKEN': $form.find('input[name="_token"]').val() },
            url: aap.stringformat('{0}/{1}', $uploaded.data('url'), file),
        }).done(removeIt);
    }

    function submitOrNot (e) {
        var $form = $('#records-form'),
            $files = $form.find('.uploaded > li'),
            /* jshint validthis:true */
            thanksPage = this.href,
            numberOfFiles = $files.size();

        function navigateToThanks() {
            window.location.href = thanksPage;
        }

        if(numberOfFiles === 0) {
            e.preventDefault();
            var ajaxData = new FormData($form.get(0));
            var xhr = $.ajax({
                url: $('.drop-zone').data('url'),
                type: $form.attr('method'),
                data: ajaxData,
                dataType: 'json',
                cache: false,
                contentType: false,
                headers:{
                    'X-CSRF-TOKEN': $form.find('input[name="_token"]').val()
                },
                processData: false
            });

            xhr.done(navigateToThanks);
        }

    }

    //init
    $('.drop-zone').each(dropAndUplaod);
    $('.uploaded').on('click', 'li', deleteIt);
    // record submission hijack
    $('.record-submit').on('click', submitOrNot);

    $('document').ready(function() {
        if ($('div.is_owner_edit_pet').length > 0) {
            var photo_count = $('div.edit-gallery').length;
            $('input[name="photo_count"]').val(photo_count);
        }
        //maybeDisableOrEnableUpload();
    });

}(jQuery, window, document));
